import React from 'react';
import { TicketFormBaseInputsBlock } from './blocks/TicketFormBaseInputsBlock';
import { TicketFormComplementaryInputsBlock } from './blocks/TicketFormComplementaryInputsBlock';
import { TicketFormErrorInfoBlock } from './blocks/TicketFormErrorInfoBlock';

const TicketFormBody = ({ ticketFormBodyData }) => {
  const { backendErrors } = ticketFormBodyData;
  const hasBackendErrors = Object.keys(backendErrors).length > 0;
  let backendErrorsMsg = 'There was an error creating the ticket';
  if (backendErrors.details === 'can_not_reach_backend')
    backendErrorsMsg = 'There was an error connecting to the server';
  const backendErrorsContent = hasBackendErrors ? JSON.stringify(backendErrors) : null;
  return (
    <>
      <TicketFormBaseInputsBlock ticketFormBodyData={ticketFormBodyData} />
      <TicketFormComplementaryInputsBlock ticketFormBodyData={ticketFormBodyData} />
      {hasBackendErrors && (
        <TicketFormErrorInfoBlock
          backendErrorsMsg={backendErrorsMsg + ' ' + backendErrorsContent}
        />
      )}
    </>
  );
};

export default TicketFormBody;
